module.exports = __webpack_public_path__ + "assets/img/25.535d365a.png";